import axios from 'axios';

const apiService = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add request interceptor to include token dynamically
apiService.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('_ipc_user_token_');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle 401 errors
apiService.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            // Token expired or invalid, redirect to login
            console.warn('Authentication failed - redirecting to login');
            
            // Clear stored authentication data
            localStorage.removeItem('_ipc_user_token_');
            localStorage.removeItem('_ipc_user_info_');
            localStorage.removeItem('_ipc_user_id_');
            localStorage.removeItem('_ipc_user_full_name_');
            localStorage.removeItem('_ipc_user_role_code_');
            localStorage.removeItem('_ipc_user_role_name_');
            
            // Redirect to login page
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default apiService;
